import React, { useState, useEffect } from 'react';
import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const AppStyle = () => {
  const [primaryColor, setPrimaryColor] = useState('red'); // Set default value
  const [secondaryColor, setSecondaryColor] = useState('blue'); // Set default value
  const [invertedColor, setTextColor] = useState('blue'); // Set default value
  const [whiteColor, setWhiteColor] = useState(0); // Set default value
  const [darkTheme, setDarkTheme] = useState(0); // Set default value
   
  useEffect(() => {
    const getStyles = async () => {
      const appInfo = await StorageHandler.load(storageKeys.appInfo);
      if (appInfo) {
        setPrimaryColor(appInfo.primaryColor);
        setSecondaryColor(appInfo.secondaryColor);
        setTextColor(appInfo.invertedColor);
        setDarkTheme(appInfo.darkTheme);
        setWhiteColor(appInfo.whiteColor);
      }
    };
    getStyles();
  }, []);

  console.log(whiteColor);

  let figcaptionColor = primaryColor;
  if (invertedColor) {
    figcaptionColor = secondaryColor;
  }
  if (darkTheme) {
    figcaptionColor = '#000';
  }

  return (
    <style>
      {`
        :root {
          --primary-color: ${primaryColor};
          --secondary-color: ${secondaryColor};
          --text-color: ${invertedColor ? secondaryColor : primaryColor};
          --app-color: ${darkTheme == 1 ? '#000' : '#fff'};
          --figcaption: ${figcaptionColor};
        }
      `}
      {whiteColor == 1 && (
        `
        a {
          color: white !important;
        }
        .header, .header-back {
          color: white !important;
        }
        button, button:hover {
          color: white !important;
        }
        nav.mini .secondaryNav li button.account svg:first-of-type {
          color: white !important;
        }
        .dropDown ul li a, .dropDown ul li button, .dropDown ul li div {
          color: #49555d !important;
        }
        .text__container .bodyContent p a {
          color: var(--text-color) !important;
        }
        .cookieConsent .cookieContent button.cookieOptOut {
          color: var(--figcaption) !important;
        }
        .text__container .bodyContent a {
          color: var(--text-color) !important;
        }
        .training .trainingBackBtn .backBtn {
          color: #49555d !important;
        }
        .navigationButton.previous {
          color: var(--text-color) !important;
        }
        .fancybox-share__input {
          color: #5d5b5b !important;
        }
        .fancybox-close-small {
          color: #5d5b5b !important;
        }
        .fancybox-button {
          color: #5d5b5b !important;
        }
        .fancybox-button.disabled, .fancybox-button.disabled:hover, .fancybox-button[disabled], .fancybox-button[disabled]:hover {
          color: #5d5b5b !important;
        }
        .fancybox-container button:hover {
          background-color: transparent;
          color: #323436 !important;
        }
        .btnInverse {
          color: var(--primary-color) !important;
        }
        .btnInverse:hover {
          color: var(--primary-color) !important;
          text-decoration: underline;
        }
        
        `
      )}
    </style>
  );
};

export default AppStyle;